import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const stats = [
  {
    title: "Member Organisations",
    value: "12",
    description: "A placeholder metric area for the future organisation dashboard.",
  },
  {
    title: "Organisation Staff",
    value: "248",
    description: "This card will later be wired to organisation-group staff totals.",
  },
  {
    title: "Usage Hours",
    value: "1,426",
    description: "Reserved for the aggregated reporting view described in the document.",
  },
];

export default function OrganisationGroupsDashboard() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <p className="organization-crumb">Dashboard</p>
          <h2>Statistics</h2>
        </div>

        <div className="organisation-tab-strip">
          <button className="organisation-tab organisation-tab-active">
            Organisations
          </button>
          <button className="organisation-tab">Staff</button>
          <button className="organisation-tab">Parents</button>
        </div>

        <Row>
            {stats.map((item) => (
              <Col lg={4} md={6} className="mt-4" key={item.title}>
                <article className="organisation-groups-card">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <span className="organisation-groups-stat">{item.value}</span>
                </article>
              </Col>
            ))}
        </Row>
      </Container>
    </OrganisationLayout>
  );
}
